import { ComponentProps } from 'react';

import { Input } from '@pletly/ui';
import i18n from '../../i18n';

export const Email = ({ ...inputProps }: ComponentProps<typeof Input>) => {
	const { t } = i18n;

	return (
		<Input
			gutter
			textContentType="emailAddress"
			keyboardType="email-address"
			inputMode="email"
			placeholder={t('common.e-mail')}
			label={t('common.e-mail')}
			autoCorrect={false}
			testID="email"
			{...inputProps}
		/>
	);
};
